module.exports = {"center":[51,10],"zoom":5}


//////////////////
// WEBPACK FOOTER
// ./src/store/defaultMap.json
// module id = 641
// module chunks = 1